import {
  __spreadValues
} from "../chunk-7B52C2XE.js";
function dispatchEvent(type, data, error) {
  typeof window !== "undefined" && !!window.dispatchEvent && window.dispatchEvent(
    new CustomEvent(type, { detail: __spreadValues({ data }, error && { error: new Error(error) }) })
  );
}
export {
  dispatchEvent
};
